// extracted by mini-css-extract-plugin
export default {"content":"AppRouter__content--1VB","header--hidden":"AppRouter__header--hidden--2Xo","cookieLayer":"AppRouter__cookieLayer--1VJ"};